require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./clients-manchester-airport-group.json") })
        }
      }, "path---clients-manchester-airport-group");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---clients-manchester-airport-group!./.cache/json/clients-manchester-airport-group.json
// module id = 1382
// module chunks = 231608221292675